'use client';
import React from 'react';
import LegalPageShell from '@/components/LegalPageShell';
import RefundPolicyContent from './components/RefundPolicyContent';

export default function RefundPolicyPage() {
  return (
    <LegalPageShell>
      <RefundPolicyContent />
    </LegalPageShell>
  );
}
